export default __webpack_public_path__ + "static/media/2475.d85cff19.svg";